<template>
	<div class="container mx-auto">
		<img class="mx-auto block h-12 relative z-10" :src="require('@/assets/pace-logo.svg')">
		<div class="flex justify-center items-center flex-col mt-4 md:flex-row md:items-start">
			<div class="w-full max-w-sm mb-4 md:mb-0 md:-mt-8 md:pt-8 md:sticky pin-t md:w-64 md:mr-8">
				<card>
					<div class="">

						<p class="text-2xl font-semibold leading-none text-center z-10 relative">Step {{ step }} of {{ steps.length }}</p>
						
						<div class="w-full shadow-inner bg-grey-lightest py-2 mt-3 mb-3 rounded overflow-hidden relative">
							<div class="h-full progressbar rounded-r absolute pin-t pin-l" :style="`width: ${(step - .5) / steps.length * 100}%`"></div>
						</div>
					</div>

					<div class="flex flex-wrap justify-between w-full flex-col sm:flex-row md:flex-col">
						<div v-for="(step, index) in steps" class="flex justify-between items-center no-underline text-black mt-2 flex-row-reverse sm:w-1/2 md:flex-row md:w-full" :key="index">
							<p class="flex-1 text-sm uppercase tracking-wide font-bold text-grey-darkest md:text-right">{{ step.name }}</p>

							<svg class="mr-2 h-5 w-5 md:ml-2 md:mr-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
								<template v-if="step.complete">
									<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
									<polyline class="text-green-dark" points="22 4 12 14.01 9 11.01"></polyline>
								</template>
								<template v-else>
									<circle cx="12" cy="12" r="10"></circle>
									<line class="text-red-dark" x1="15" y1="9" x2="9" y2="15"></line>
									<line class="text-red-dark" x1="9" y1="9" x2="15" y2="15"></line>
								</template>
							</svg>
						</div>
					</div>
				</card>
			</div>
			<card class="w-full max-w-sm">
				<router-view/>
			</card>
		</div>
	</div>
</template>

<script>
	import Card from '@/components/Card'
	import store from '@/store'

	export default {
		beforeRouteEnter(to, from, next) {
			store.commit('initialize')

			const incompleteSteps = store.state.steps.filter(step => {
				return !step.complete
			})

			if (incompleteSteps.length === store.state.steps.length && !from.path.includes('/position/')) {
				if (store.state.position === null) {
					window.location = 'https://www.paceintl.com/careers'
				}

				next(`/position/${store.state.position.replace(/\s/g, '-').toLowerCase()}`)
				
				return
			}

			next()
		},

		components: {
			Card,
		},

		computed: {
			step() {
				return this.steps.filter(step => step.complete).length + 1
			},

			steps() {
				return this.$store.state.steps
			},
		}
	}
</script>

<style scoped>
	.progressbar {
		@apply overflow-hidden;
	}

	.progressbar::after {
		@apply absolute h-screen pin-t pin-r;
		
		width: 9000px;
		content: '';
		background-size: 4500px;
		background-image: repeating-linear-gradient(90deg, config('colors.green-dark'), config('colors.green') 10%); 

		animation: filling 2s linear infinite;
	}

	@keyframes filling {
		from {
			transform: translateX(0);
		}

		to {
			transform: translateX(10%);
		}
	}
</style>
